import * as React from 'react';

function SvgHelpCenterThingsToKnow(props) {
  return (
    <svg width={63} height={65} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M39 19.6c9.72 0 17.6 7.88 17.6 17.6 0 6.84-3.9 12.767-9.6 15.68V63.4a1 1 0 01-1 1H33.6a1 1 0 01-1-1v-9.8c-6.556-2.56-11.2-8.938-11.2-16.4 0-9.72 7.88-17.6 17.6-17.6z"
          fill="#E2F4F2"
        />
        <path
          d="M31 14.32c-9.985 0-18.08 8.095-18.08 18.08 0 9.985 8.095 18.08 18.08 18.08 9.986 0 18.08-8.095 18.08-18.08 0-9.985-8.094-18.08-18.08-18.08zm0 4.16c7.688 0 13.92 6.232 13.92 13.92S38.688 46.32 31 46.32 17.08 40.088 17.08 32.4 23.312 18.48 31 18.48z"
          fill="#38B2A6"
          fillRule="nonzero"
        />
        <path
          d="M39.48 46.32H24.12V56.4a3.68 3.68 0 003.68 3.68h8a3.68 3.68 0 003.68-3.68V46.32zm-4.16 4.16v5.44h-7.04v-5.44h7.04z"
          fill="#38B2A6"
          fillRule="nonzero"
        />
        <path
          d="M31.903 33.52a2.08 2.08 0 012.07 1.867l.01.213v12.069a2.08 2.08 0 01-4.149.212l-.01-.212-.002-9.989H26.2a2.08 2.08 0 01-2.07-1.867l-.01-.213a2.08 2.08 0 011.868-2.07l.212-.01h5.703zm-.103 23.2a2.08 2.08 0 012.07 1.867l.01.213V62a2.08 2.08 0 01-4.15.213L29.72 62v-3.2a2.08 2.08 0 012.08-2.08zm0-56a2.08 2.08 0 012.07 1.867l.01.213v4.8a2.08 2.08 0 01-4.15.213l-.01-.213V2.8A2.08 2.08 0 0131.8.72zm19.928 10.41a2.08 2.08 0 013.094 2.773l-.152.169-3.394 3.394a2.08 2.08 0 01-3.093-2.773l.151-.169 3.394-3.394zM11.276 11.13a2.08 2.08 0 00-3.094 2.773l.152.169 3.394 3.394a2.08 2.08 0 003.093-2.773l-.151-.169-3.394-3.394zM51.728 54.266a2.08 2.08 0 003.094-2.773l-.152-.169-3.394-3.394a2.08 2.08 0 00-3.093 2.773l.151.169 3.394 3.394zM11.276 54.266a2.08 2.08 0 01-3.094-2.773l.152-.169 3.394-3.394a2.08 2.08 0 013.093 2.773l-.151.169-3.394 3.394zM59.982 30.759a2.08 2.08 0 01.213 4.15l-.213.01h-4.8a2.08 2.08 0 01-.213-4.15l.213-.01h4.8zM2.382 30.759a2.08 2.08 0 00-.213 4.15l.213.01h4.8a2.08 2.08 0 00.213-4.15l-.213-.01h-4.8z"
          fill="#38B2A6"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default SvgHelpCenterThingsToKnow;
